var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgChatSticker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10.668C6.56667 11.088 7.25667 11.3346 8 11.3346C8.74333 11.3346 9.43333 11.088 10 10.668",
    stroke: "#A7A7A7",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8C10.3682 8 10.6667 7.55228 10.6667 7C10.6667 6.44772 10.3682 6 10 6C9.63185 6 9.33337 6.44772 9.33337 7C9.33337 7.55228 9.63185 8 10 8Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00004 8C6.36823 8 6.66671 7.55228 6.66671 7C6.66671 6.44772 6.36823 6 6.00004 6C5.63185 6 5.33337 6.44772 5.33337 7C5.33337 7.55228 5.63185 8 6.00004 8Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.6673H8.00004C4.85737 14.6673 3.28604 14.6673 2.30937 13.6907C1.33337 12.7153 1.33337 11.1433 1.33337 8.00065C1.33337 4.85798 1.33337 3.28665 2.30937 2.30998C3.28671 1.33398 4.85737 1.33398 8.00004 1.33398C11.1427 1.33398 12.714 1.33398 13.69 2.30998C14.6667 3.28732 14.6667 4.85798 14.6667 8.00065V10.0007M10 14.6673C11.2377 14.6673 12.4247 14.1757 13.2999 13.3005C14.175 12.4253 14.6667 11.2383 14.6667 10.0007M10 14.6673C10 13.4267 10 12.806 10.1634 12.304C10.3259 11.8037 10.6046 11.3491 10.9765 10.9771C11.3484 10.6052 11.8031 10.3265 12.3034 10.164C12.8054 10.0007 13.426 10.0007 14.6667 10.0007",
    stroke: "#A7A7A7",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSticker);
export default __webpack_public_path__ + "static/media/chat-sticker.b0061b96ac87a143208278fb2fa5006d.svg";
export { ForwardRef as ReactComponent };